module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contribute-modal"
  }, [(_vm.success) ? _c('div', [_c('h2', [_c('translate', {
    attrs: {
      "translate-context": "contribute popup"
    }
  }, [_vm._v("Thank you!")])], 1), _vm._v(" "), _c('p', [_c('translate', {
    attrs: {
      "translate-context": "contribute popup"
    }
  }, [_vm._v("Here is your access code. Please keep it safely.")])], 1), _vm._v(" "), _c('p', [_c('translate', {
    attrs: {
      "translate-context": "contribute popup"
    }
  }, [_vm._v("\n        Username:\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(this.success.email))])], 1), _vm._v(" "), _c('p', [_c('translate', {
    attrs: {
      "translate-context": "contribute popup"
    }
  }, [_vm._v("\n        Password:\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(this.success.password))])], 1), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "light",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("Close")])], 1)])]) : _c('div', [_c('h2', [_c('translate', {
    attrs: {
      "translate-context": "contribute popup"
    }
  }, [_vm._v("Join Meteo-Parapente contributors club")])], 1), _vm._v(" "), _c('p', [_c('small', [_c('translate', {
    attrs: {
      "translate-context": "contribute popup"
    }
  }, [_vm._v("\n          Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!\n        ")])], 1)]), _vm._v(" "), _c('p', [_c('small', [_c('translate', {
    attrs: {
      "translate-context": "contribute popup"
    }
  }, [_vm._v("\n          Support the development of a quality tool accessible to every pilots.\n        ")])], 1)]), _vm._v(" "), _c('p', [_c('small', [_c('translate', {
    attrs: {
      "translate-context": "contribute popup"
    }
  }, [_vm._v("\n          Get free entry to local weather trainings and users meetups.\n        ")]), _vm._v(" "), _vm._m(0)], 1)]), _vm._v(" "), _c('p', [_c('small', [_c('translate', {
    attrs: {
      "translate-context": "contribute popup"
    }
  }, [_vm._v("\n          Meet me once a month to discuss new features and improvements.\n        ")]), _vm._v(" "), (_vm.$language.current === 'fr') ? _c('a', {
    attrs: {
      "href": "https://community.meteo-parapente.com/t/soirees-retours-et-ameliorations-fr/1055",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })]) : _c('a', {
    attrs: {
      "href": "https://community.meteo-parapente.com/t/feedbacks-and-improvements-online-meetups-en/1056",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])], 1)]), _vm._v(" "), _c('p', [_c('small', [_c('translate', {
    attrs: {
      "translate-context": "private popup"
    }
  })], 1)]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.contribute($event)
      }
    }
  }, [_c('p', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product),
      expression: "product"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1-year-standard"
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "contribute popup",
      "translate-params": {
        currency: _vm.currencySymbol,
        pricing: _vm.pricing.standard
      }
    }
  }, [_vm._v("\n                12 months Standard － %{currency} %{pricing} / month\n              ")])], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1-year-supporter"
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "contribute popup",
      "translate-params": {
        currency: _vm.currencySymbol,
        pricing: _vm.pricing.supporter
      }
    }
  }, [_vm._v("\n                12 months Supporter － %{currency} %{pricing} / month\n              ")])], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1-year-reduced"
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "contribute popup",
      "translate-params": {
        currency: _vm.currencySymbol,
        pricing: _vm.pricing.reduced
      }
    }
  }, [_vm._v("\n                 12 months Student － %{currency} %{pricing} / month\n              ")])], 1)])]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email1),
      expression: "email1"
    }],
    attrs: {
      "type": "email",
      "placeholder": _vm.$pgettext('contribute popup', 'Email')
    },
    domProps: {
      "value": (_vm.email1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email1 = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.forceErrorMessage) ? _c('p', {
    staticClass: "error"
  }, [_c('translate', {
    attrs: {
      "translate-context": "contribute popup"
    }
  }, [_vm._v("\n          Emails are not the same or invalid\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "keyboard-submit-bug-fix"
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("OK")])], 1)]), _vm._v(" "), (_vm.loading) ? _c('p', {
    staticClass: "high"
  }, [_c('img', {
    attrs: {
      "src": "img/load.gif"
    }
  })]) : _c('p', [_c('button', {
    on: {
      "click": function($event) {
        _vm.contribute()
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("OK")])], 1), _vm._v(" "), _c('button', {
    staticClass: "light",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("Close")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://community.meteo-parapente.com/t/tour-of-europe-part-1/968",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c97e3b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/contribute.vue
// module id = 335
// module chunks = 1